import { useState } from "react";
import { DisplayMsg } from "../../services/toastService";
import { EMAIL_REGEX } from "../../constants/regex";
import { setUrl } from "../../handlers";

const Forgot = (props) => {
  const [Forgot, setForgot] = useState({ email: "", emailErr: "" });

  const ForgotPopup = () => {
    props.parentCallback(false);
  };

  const CheckEmail = (e) => {
    if (e.target.value < 1) {
      setForgot((forgotInfo) => ({
        ...forgotInfo,
        emailErr: "Required",
      }));
    } else {
      const check = EMAIL_REGEX.test(e.target.value);

      setForgot((info) => ({
        ...info,
        emailErr: check === false ? "❌ Email is not valid!" : "",
      }));
    }
  };

  const ManageEmail = (e) => {
    e.preventDefault();
    const {name} = e.target;
    const currVal = e.target.value;
    switch (name) {
      case "email":
        let emailResult = "";
        if (currVal.length < 1) {
          emailResult = "Required";
        } else {
          const check = EMAIL_REGEX.test(currVal);
          emailResult = check === false ? "❌ Email is not valid!" : "";
        }
        setForgot((forgotInfo) => ({
          ...forgotInfo,
          email: currVal,
          emailErr: emailResult,
        }));
        break;
      default:
        break;
    }
  };

  const SendEmail = async () => {
    try {
      if (Forgot.email === "") {
        setForgot((forgotInfo) => ({
          ...forgotInfo,
          emailErr: "Required",
        }));
        return false;
      }
      const formData = new FormData();
      formData.append("USERNAME", Forgot.email);
      document.getElementById("loader").style.display = "block";
      const result = await fetch(setUrl("FORGOTPASSWORD", "SENDPASSWORD"), {
        method: "POST",
        body: formData,
      });
      const response = await result.json();
      if (
        response.status !== false &&
        response.Message !== "Invalid user email id"
      ) {
        DisplayMsg("1", response.Message);
        ForgotPopup();
      } else {
        DisplayMsg("2", response.Message);
      }
    } catch (e) {
      DisplayMsg("2", "Unabale to Process the Request...");
    }
  };

  return (
    <>
      <div className="errorMsgPanel" />
      <div className="successMsgPanel" />
      <div className="overlay">
        <div className="popup change-password">
          <div className="popup__header">
            <h3>Forgot Password</h3>
            <span
              className="close"
              role="button"
              onClick={() => ForgotPopup(false)}
            >
              ×
            </span>
          </div>
          <div className="align-items-center content d-flex">
            <div className="popup__body w-full">
              <div className="row">
                <div className="col-md-6 col-sm-6 m-auto">
                  <div className="field-container mb-0">
                    <label className="field-placeholder font-medium">
                      Email
                    </label>
                    <input
                      className="field-input"
                      type="text"
                      name="email"
                      onFocus={(e) => CheckEmail(e)}
                      onChange={(e) => ManageEmail(e)}
                      value={Forgot.email}
                      maxLength="255"
                    />
                  </div>
                  <span
                    className={`${
                      Forgot.emailErr.length > 1 ? "d-block" : "d-none"
                    } text-sm text-red-500`}
                  >
                    {Forgot.emailErr}
                  </span>
                </div>
              </div>
              <div className="row text-center mt-3">
                <div className="col-md-12 col-sm-12">
                  <label>&nbsp;</label>
                  <input
                    type="button"
                    className="btnLinkBlue"
                    value="Search"
                    onClick={() => SendEmail()}
                  />
                  <input
                    type="button"
                    className="btnCancel ClosePopup"
                    value="Cancel"
                    onClick={() => ForgotPopup()}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Forgot;
